import DateIT from "./DateIT";

// Form "Crea con Claude": brief libero -> genera email HTML
export function AiGenForm({ aiBrief, setAiBrief, genFormat, setGenFormat, onGenerate, onCancel, busy }) {
  return (
    <div className="panel" style={{ marginTop: 10, background: "rgba(56,189,248,.08)" }} data-testid="composer-gen-form">
      <div className="field"><label>✨ Crea l'email con Claude — descrivi cosa deve dire</label>
        <textarea rows={3} value={aiBrief} onChange={(e) => setAiBrief(e.target.value)} placeholder="Es. Invita i clienti a inviare i documenti per la dichiarazione dei redditi entro il 30 settembre, tono cordiale e professionale" data-testid="composer-gen-brief" />
      </div>
      <div className="toolbar" style={{ gap: 14, flexWrap: "wrap" }}>
        <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
          <input type="radio" name="gen-format" checked={genFormat === "text"} onChange={() => setGenFormat("text")} data-testid="composer-gen-format-text" style={{ margin: 0 }} />
          📝 Testo normale (nel corpo, modificabile, con firma)
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
          <input type="radio" name="gen-format" checked={genFormat === "html"} onChange={() => setGenFormat("html")} data-testid="composer-gen-format-html" style={{ margin: 0 }} />
          🎨 Email grafica HTML (stile newsletter)
        </label>
      </div>
      <div className="toolbar" style={{ gap: 8 }}>
        <button type="button" className="btn primary" onClick={onGenerate} disabled={busy === "gen"} data-testid="composer-gen-btn">{busy === "gen" ? "Genero…" : "Genera email"}</button>
        <button type="button" className="btn" onClick={onCancel}>Annulla</button>
      </div>
    </div>
  );
}

// Chip degli allegati: visualizza, scarica, rimuovi
const attBlobUrl = (a) => {
  const bin = atob(a.content_b64 || "");
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
  return URL.createObjectURL(new Blob([bytes], { type: a.content_type || "application/octet-stream" }));
};

export function AttachmentChips({ attachments, onRemove }) {
  if (!attachments.length) return null;
  const openAtt = (a) => {
    if (!a.content_b64) return;
    const u = attBlobUrl(a);
    window.open(u, "_blank");
    setTimeout(() => URL.revokeObjectURL(u), 60000);
  };
  const dlAtt = (a) => {
    if (!a.content_b64) return;
    const u = attBlobUrl(a);
    const l = document.createElement("a");
    l.href = u;
    l.download = a.filename || "allegato";
    document.body.appendChild(l);
    l.click();
    l.remove();
    setTimeout(() => URL.revokeObjectURL(u), 5000);
  };
  return (
    <div className="toolbar" style={{ gap: 6, flexWrap: "wrap", marginTop: 6 }} data-testid="composer-attachments">
      {attachments.map((a, i) => (
        <span key={`${a.filename}-${a.size}-${i}`} className="pill" style={{ background: "rgba(99,102,241,.15)", display: "inline-flex", alignItems: "center", gap: 4 }}>
          <button type="button" onClick={() => openAtt(a)} title="Visualizza l'allegato" style={{ cursor: "pointer", background: "none", border: "none", color: "inherit", padding: 0, font: "inherit", textDecoration: "underline dotted" }} data-testid={`composer-attach-open-${i}`}>
            📎 {a.filename}
          </button>
          <button type="button" onClick={() => dlAtt(a)} title="Scarica per controllare" style={{ cursor: "pointer", background: "none", border: "none", color: "inherit", padding: "0 2px" }} data-testid={`composer-attach-download-${i}`}>⬇️</button>
          <button type="button" onClick={() => onRemove(i)} title="Rimuovi" style={{ cursor: "pointer", background: "none", border: "none", color: "inherit", padding: "0 2px" }} data-testid={`composer-attach-remove-${i}`}>✕</button>
        </span>
      ))}
    </div>
  );
}

// Form creazione evento Google Calendar
export function EventForm({ evDate, setEvDate, evTime, setEvTime, evDur, setEvDur, onCreate, busy }) {
  return (
    <div className="panel" style={{ marginTop: 10 }} data-testid="composer-event-form">
      <div className="toolbar" style={{ gap: 8, flexWrap: "wrap", alignItems: "flex-end" }}>
        <div className="field" style={{ margin: 0 }}><label>Data</label><DateIT value={evDate} onChange={(v) => setEvDate(v)} data-testid="composer-event-date" /></div>
        <div className="field" style={{ margin: 0 }}><label>Ora</label><input type="time" value={evTime} onChange={(e) => setEvTime(e.target.value)} data-testid="composer-event-time" /></div>
        <div className="field" style={{ margin: 0, maxWidth: 110 }}><label>Durata (min)</label><input type="number" value={evDur} onChange={(e) => setEvDur(e.target.value)} data-testid="composer-event-dur" /></div>
        <button type="button" className="btn primary" onClick={onCreate} disabled={busy === "event"} data-testid="composer-event-create">Crea su Calendar</button>
      </div>
    </div>
  );
}
